export type DndLanguage = "he" | "en";

export type DndContent = {
  dir: "rtl" | "ltr";
  lang: DndLanguage;
  metaTitle: string;
  metaDescription: string;
  nav: string[];
  navLabel: string;
  languageLabel: string;
  title: string;
  titleAccent: string;
  eyebrow: string;
  intro: string;
  cta: string;
  ctaLabel: string;
  facts: [string, string][];
  aboutKicker: string;
  aboutTitle: string;
  aboutBody: string;
  aboutNote: string;
  benefitsTitle: string;
  benefits: [string, string][];
  journeyKicker: string;
  journeyTitle: string;
  journey: [string, string, string][];
  hostKicker: string;
  hostTitle: string;
  hostBody: string;
  hostNote: string;
  hostPortraitAlt: string;
  hostStats: [string, string][];
  detailsKicker: string;
  detailsTitle: string;
  details: [string, string][];
  finalKicker: string;
  finalTitle: string;
  finalBody: string;
  finalCta: string;
  footer: string;
};

export const DND_WHATSAPP_URL =
  "https://wa.me/972515097499?text=%D7%94%D7%99%D7%99!%20%D7%90%D7%A9%D7%9E%D7%97%20%D7%9C%D7%A8%D7%A9%D7%95%D7%9D%20%D7%90%D7%AA%20%D7%94%D7%99%D7%9C%D7%93.%D7%94%20%D7%A9%D7%9C%D7%99%20%D7%9C%D7%97%D7%95%D7%92%20%D7%9E%D7%91%D7%95%D7%9B%D7%99%D7%9D%20%D7%95%D7%93%D7%A8%D7%A7%D7%95%D7%A0%D7%99%D7%9D%20%D7%A2%D7%9D%20%D7%90%D7%9C%D7%9B%D7%A1%D7%A0%D7%93%D7%A8%D7%94";

export const DND_CONTENT: Record<DndLanguage, DndContent> = {
  he: {
    dir: "rtl",
    lang: "he",
    metaTitle: "מבוכים ודרקונים בנווה איתן | Unschool",
    metaDescription:
      "חוג מבוכים ודרקונים שבועי לילדים בגילאי 10–14 בנווה איתן. קבוצה קטנה, הרפתקה מתמשכת ומתאים גם למתחילים.",
    nav: ["על החוג", "מה עושים", "על אלכסנדרה", "פרטים"],
    navLabel: "ניווט ראשי",
    languageLabel: "בחירת שפה",
    title: "מבוכים ודרקונים",
    titleAccent: "בנווה איתן",
    eyebrow: "הרפתקה שבועית לילדים מגיל 10 עד 14",
    intro:
      "יוצרים דמות, פותרים חידות, מקבלים החלטות ועובדים יחד כקבוצה בעולם שבו כל בחירה משנה את הסיפור.",
    cta: "הצטרפו להרפתקה",
    ctaLabel: "הרשמה לחוג מבוכים ודרקונים דרך WhatsApp",
    facts: [
      ["ימי שלישי", "בערב"],
      ["90", "דקות"],
      ["עד 5 ילדים", "בקבוצה"],
      ["₪270", "לחודש"],
    ],
    aboutKicker: "מה זה מבוכים ודרקונים?",
    aboutTitle: "הסיפור נוצר סביב השולחן",
    aboutBody:
      "זה משחק קבוצתי שבו כל ילד יוצר דמות משלו, יוצא להרפתקה, פותר חידות, מקבל החלטות ועובד יחד עם שאר הקבוצה כדי להתמודד עם אתגרים ומפלצות.",
    aboutNote:
      "לא צריך ניסיון קודם. מתחילים יחד, לומדים את הכללים תוך כדי משחק ובונים הרפתקה מתמשכת שבה לכל ילד יש מקום להשפיע.",
    benefitsTitle: "הרבה יותר ממשחק",
    benefits: [
      ["יצירתיות", "מדמיינים עולמות, ממציאים פתרונות ומספרים סיפור משותף."],
      ["חשיבה", "קוראים מצבים, פותרים חידות ובוחנים מה יקרה בעקבות כל החלטה."],
      ["עבודת צוות", "מקשיבים, משתפים פעולה ומגלים שלכל דמות יש כוח אחר."],
      [
        "ביטחון עצמי",
        "מקבלים החלטות, מביעים רעיונות ורואים איך הם משנים את העלילה.",
      ],
    ],
    journeyKicker: "מה עושים בחוג?",
    journeyTitle: "מהדמות הראשונה ועד להרפתקה הגדולה",
    journey: [
      [
        "01",
        "יוצרים דמות",
        "בוחרים מי נהיה, מה אנחנו יודעים לעשות ומה הסיפור שלנו.",
      ],
      [
        "02",
        "נכנסים לעולם",
        "מכירים מקומות, דמויות, חידות וסכנות שמחכות מעבר לפינה.",
      ],
      [
        "03",
        "בוחרים יחד",
        "כל החלטה מקדמת את העלילה לכיוון אחר — אין תשובה אחת נכונה.",
      ],
      [
        "04",
        "גדלים כקבוצה",
        "לומדים לסמוך זה על זה וממשיכים קמפיין שנבנה משבוע לשבוע.",
      ],
    ],
    hostKicker: "מי מובילה את ההרפתקה?",
    hostTitle: "נעים להכיר, אלכסנדרה",
    hostBody:
      "מורה ומחנכת עם 10 שנות ניסיון בעבודה עם ילדים, שחקנית מבוכים ודרקונים כבר 10 שנים ומנחת משחקים במשך 3 שנים.",
    hostNote:
      "המטרה שלי היא ליצור מרחב קטן, בטוח ומעודד שבו ילדים יכולים לנסות, לטעות, להעז ולהרגיש שהרעיונות שלהם באמת חשובים.",
    hostPortraitAlt: "אלכסנדרה, מנחת החוג",
    hostStats: [
      ["10", "שנות חינוך"],
      ["10", "שנות משחק"],
      ["3", "שנות הנחיה"],
    ],
    detailsKicker: "הפרטים החשובים",
    detailsTitle: "כל מה שצריך לדעת",
    details: [
      ["למי?", "ילדים מגיל 10 עד 14. מתאים במיוחד למתחילים"],
      ["מתי?", "פעם בשבוע, בימי שלישי בערב. כל מפגש נמשך 90 דקות"],
      [
        "כמה משתתפים?",
        "עד 5 ילדים בקבוצה, כדי שלכל אחד יהיה מקום אמיתי בסיפור",
      ],
      ["כמה זה עולה?", "₪270 לחודש"],
      ["איפה?", "בנווה איתן"],
      [
        "מתי מתחילים?",
        "מועד הפתיחה והשעות המדויקות ייקבעו לפי מספר הנרשמים. במידת הצורך ייפתחו שתי קבוצות או יותר",
      ],
    ],
    finalKicker: "ההרפתקה הבאה כבר מחכה",
    finalTitle: "רוצים לשמור מקום בקבוצה?",
    finalBody:
      "שלחו הודעה ב־WhatsApp. אשמח להכיר, לענות על שאלות ולעדכן ברגע שזמני הקבוצות ייסגרו.",
    finalCta: "דברו איתי ב־WhatsApp",
    footer: "מבוכים ודרקונים בנווה איתן · בהנחיית אלכסנדרה",
  },
  en: {
    dir: "ltr",
    lang: "en",
    metaTitle: "Dungeons & Dragons in Neve Eitan | Unschool",
    metaDescription:
      "A weekly Dungeons & Dragons club for children ages 10–14 in Neve Eitan. Small group, an ongoing campaign and perfect for beginners.",
    nav: ["About the club", "What we do", "About Alexandra", "Details"],
    navLabel: "Main navigation",
    languageLabel: "Language selection",
    title: "Dungeons & Dragons",
    titleAccent: "in Neve Eitan",
    eyebrow: "A weekly adventure for ages 10–14",
    intro:
      "Create a character, solve riddles, make choices and work together in a world where every decision shapes the story.",
    cta: "Join the adventure",
    ctaLabel: "Register for the Dungeons & Dragons club via WhatsApp",
    facts: [
      ["Tuesday", "evenings"],
      ["90", "minutes"],
      ["Up to 5 kids", "per group"],
      ["₪270", "per month"],
    ],
    aboutKicker: "What is Dungeons & Dragons?",
    aboutTitle: "The story is created around the table",
    aboutBody:
      "It is a collaborative game in which every child creates a character, sets out on an adventure, solves riddles, makes decisions and works with the group to face challenges and monsters.",
    aboutNote:
      "No previous experience is needed. We start together, learn the rules through play and build an ongoing adventure where every child can shape the story.",
    benefitsTitle: "Much more than a game",
    benefits: [
      [
        "Creativity",
        "Imagine worlds, invent solutions and tell one shared story.",
      ],
      [
        "Thinking",
        "Read situations, solve riddles and explore the consequences of each choice.",
      ],
      [
        "Teamwork",
        "Listen, cooperate and discover that every character brings a different strength.",
      ],
      [
        "Confidence",
        "Make decisions, express ideas and see how they change the adventure.",
      ],
    ],
    journeyKicker: "What happens at the club?",
    journeyTitle: "From a first character to a grand adventure",
    journey: [
      [
        "01",
        "Create a character",
        "Choose who you are, what you can do and the story you bring.",
      ],
      [
        "02",
        "Enter the world",
        "Discover places, characters, riddles and dangers around every corner.",
      ],
      [
        "03",
        "Choose together",
        "Every decision sends the story in a new direction—there is no single right answer.",
      ],
      [
        "04",
        "Grow as a group",
        "Learn to trust one another and continue a campaign that develops every week.",
      ],
    ],
    hostKicker: "Who guides the adventure?",
    hostTitle: "Meet Alexandra",
    hostBody:
      "An educator with 10 years of experience working with children, a D&D player for 10 years and a Game Master for 3 years.",
    hostNote:
      "My goal is to create a small, safe and encouraging space where children can experiment, make mistakes, be brave and feel that their ideas genuinely matter.",
    hostPortraitAlt: "Alexandra, the club’s Game Master",
    hostStats: [
      ["10", "years teaching"],
      ["10", "years playing"],
      ["3", "years GMing"],
    ],
    detailsKicker: "The important details",
    detailsTitle: "Everything you need to know",
    details: [
      [
        "Who is it for?",
        "Children ages 10–14. Especially suitable for complete beginners",
      ],
      [
        "When?",
        "Once a week on Tuesday evenings. Each session lasts 90 minutes",
      ],
      [
        "Group size?",
        "Up to 5 children, so everyone has a meaningful place in the story",
      ],
      ["Price?", "₪270 per month"],
      ["Where?", "Neve Eitan"],
      [
        "When does it start?",
        "The opening date and exact times will be set according to registration. Two or more groups may open if needed",
      ],
    ],
    finalKicker: "Your next adventure is waiting",
    finalTitle: "Want to reserve a place?",
    finalBody:
      "Send me a WhatsApp message. I’ll be happy to meet you, answer questions and update you as soon as the group times are confirmed.",
    finalCta: "Message me on WhatsApp",
    footer: "Dungeons & Dragons in Neve Eitan · Guided by Alexandra",
  },
};
